const PropertiesSandbox = {
	init(vueStoreChannel) {
		pp.log("Init PropertiesSandbox -- vueStoreChannel", vueStoreChannel);
		$(document)
			.on("mouseenter", ".j-apm-source", function () {
				var sourceId = $(this).attr("data-source-id");
				$(
					`[data-has-apms-from-source-ids*='-${sourceId}-'], [data-source-id='${sourceId}']`,
				)
					.css("font-weight", "500")
					.css("color", "blue");

				// If this is an anchor tag: find the nested calculated value from the overlay and append it to the overlay's parent
				if ($(this).prop("tagName") == "A") {
					$(`[data-has-apms-from-source-ids*='-${sourceId}-']`).each(
						function () {
							$(this)
								.find(
									`.OverlayContainer .j-calculated-value[data-source-id='${sourceId}']`,
								)
								.removeClass("hidden");
						},
					);
				}
			})
			.on("mouseleave", ".j-apm-source", function () {
				var sourceId = $(this).attr("data-source-id");
				$(
					`[data-has-apms-from-source-ids*='-${sourceId}-'], [data-source-id='${sourceId}']`,
				).removeAttr("style");
				// Remove the cloned element with the calculated value again
				$(`[data-has-apms-from-source-ids*='-${sourceId}-']`).each(function () {
					$(this)
						.find(
							`.OverlayContainer .j-calculated-value[data-source-id='${sourceId}']`,
						)
						.addClass("hidden");
				});
			});

		// Simulate the default bootstrap behavior that adds 'collapsed' to the collapsING link, somehow this doesn't work here
		// Also toggle the plus and minus signs inside the link
		$(".Table--stats__toggle-row-link").on(
			"show.bs.collapse hide.bs.collapse click",
			function (event) {
				var $target = $(this);
				// Uncollapse all target elements, also the deeply nested ones, rather than *toggling* the collapse state
				if ($target.hasClass("collapsed")) {
					// @ts-expect-error
					$($target.attr("href")).addClass("in");
					// Mark the nested links pointing to the collapsible table rows as uncollapsed, because their resp targets are now uncollapsed
					// @ts-expect-error
					$($target.attr("href"))
						// @ts-expect-error
						.find(".Table--stats__toggle-row-link")
						.removeClass("collapsed");
				} else {
					// Collapse all target elements, also the deeply nested ones, rather than *toggling* the collapse state
					// @ts-expect-error
					$($target.attr("href")).removeClass("in");
				}
				$target.toggleClass("collapsed");
				return false;
			},
		);

		$(document).on("click", ".j-pin-link", function () {
			var $ownActorRow = $(this).closest("tr[data-actor-id]");
			var $tableHead = $(this).closest("table").find("thead").first();
			var $currentFirstRow = $(this).closest("tbody").children().first();
			if ($currentFirstRow.attr("style") !== undefined) {
				// Means that it is actually a pinned row, not a normal one
				var returnAfterRemove =
					$currentFirstRow.attr("data-actor-id") ==
					$ownActorRow.attr("data-actor-id");
				$currentFirstRow.remove();
				$tableHead.removeAttr("style");
				if (returnAfterRemove) {
					return;
				}
			}
			$("tr[data-actor-id]").removeAttr("style");
			// @ts-expect-error
			var $clonedActorRow = $(this).closest("tr[data-actor-id]").clone().css({
				position: "fixed",
				display: "table",
				"table-layout": "fixed",
				"z-index": "1100",
				width: "100%",
				top: $tableHead.outerHeight(),
				"border-bottom": "1px red dashed",
			});
			$(this).closest("tbody").prepend($clonedActorRow);
			$tableHead.css({
				position: "fixed",
				display: "table",
				"table-layout": "fixed",
				"z-index": "1100",
				width: "100%",
				top: 0,
				"background-color": "#fff",
			});
		});

		pp.global.initSelect2For($("#measure_actor_id"));
		$("#measure_actor_id").on("change", function () {
			// @ts-expect-error
			var actorId = this.value;
			$("div[data-measure-id] a[data-method]").each(function (index, elem) {
				var hrefToUpdate = $(elem).attr("data-stored-href");
				// @ts-expect-error
				hrefToUpdate = hrefToUpdate.split("&actor_id=")[0];
				hrefToUpdate += "&actor_id=" + actorId;
				// @ts-expect-error
				$(elem).attr("data-stored-href", hrefToUpdate);
			});
		});
		setTimeout(function () {
			$("#measure_actor_id").trigger("change");
		}, 100);

		// Just a stub for now, the update of the ActorProperty/Phase table cells is still done via `sandbox_pass_vote.js.erb`
		// PrivatePub.subscribe(vueStoreChannel, function(data, channel) {
		// 	pp.log("incoming", data);
		// 	for (let index in data.newApps) {
		// 		const app = data.newApps[index];
		// 		// pp.log("at entry", app);
		// 	}
		// });
	},
};

export default PropertiesSandbox;
